import React, { Component } from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment-timezone';

import { Logo } from 'assets/images';
import './styles.scss';

interface IState {
  companyName: string;
  expiration: number;
  notes: string;
  timeZone: string;
  success: boolean;
}

interface IMatchParams {
  id: string;
  signature: string;
}

class ClearshareEmail extends Component<RouteComponentProps<IMatchParams>, IState> {
  constructor(props) {
    super(props);

    this.state = {
      companyName: '',
      expiration: 0,
      notes: '',
      timeZone: '',
      success: false,
    };
  }

  async componentDidMount() {
    try {
      const response = await this.fetchDetails();
      const data = response.data;

      await this.setDetails(data.companyName, data.expiration, data.notes, data.timeZone);
      this.setState({ success: true });
    } catch (e) {
      this.props.history.push('/map');
    }
  }

  fetchDetails = () => {
    const {
      match: {
        params: { id, signature },
      },
    } = this.props;

    return axios.get(`${process.env.REACT_APP_API_HOST}/v1.0/clearshare/details?id=${id}&signature=${signature}`);
  };

  setDetails = (companyName, expiration, notes, timeZone) => {
    this.setState({
      companyName,
      expiration,
      notes,
      timeZone,
    });
  };

  render() {
    const { companyName, expiration, notes, timeZone, success } = this.state;
    const {
      match: {
        params: { id, signature },
      },
    } = this.props;
    const mapPath = `/map/${id}/${signature}`;

    return (
      success && (
        <div className="ClearshareEmail">
          <img
            className="ClearshareEmail-mapImage"
            src="https://public-data.clearpathgps.com/clearshare-map-bg.jpg"
            alt="Map"
          />

          <div className="ClearshareEmail-content">
            <header className="ClearshareEmail-header">
              You’ve been invited {companyName ? `by ${companyName}` : ''} to see the location of a vehicle in their
              fleet using ClearPathGPS.
            </header>
            {notes && (
              <p className="ClearshareEmail-text ClearshareEmail-text--small ClearshareEmail-text--note">
                Note from Sender: {notes}
              </p>
            )}
            <Link to={mapPath} className="ClearshareEmail-button">
              See Vehicle’s Location
            </Link>
            <div className="ClearshareEmail-link">
              <p className="ClearshareEmail-text ClearshareEmail-text--medium ClearshareEmail-text--copyLink">
                Having trouble viewing the link? Copy/Paste this URL:
              </p>
              <Link to={mapPath} className="ClearshareEmail-linkSource">
                {`${window.location.host}${mapPath}`}
              </Link>
            </div>
            <p className="ClearshareEmail-text ClearshareEmail-text--medium ClearshareEmail-text--expiry">
              This link is currently set to expire{' '}
              <span className="ClearshareEmail-expiryTime">
                {moment(expiration).tz(timeZone)?.calendar()} {timeZone}
              </span>
            </p>
            <p className="ClearshareEmail-text ClearshareEmail-text--small ClearshareEmail-text--privacy">
              This link is meant to show an estimation of the vehicle location and is not an exact representation.
              Locations are updated on a delay to protect the driver’s privacy.
            </p>
            <div className="ClearshareEmail-footer">
              <p className="ClearshareEmail-text ClearshareEmail-text--small ClearshareEmail-text--poweredBy">
                This vehicle tracking service is powered by
              </p>
              <Logo className="ClearshareEmail-logo" width={200} />
            </div>
          </div>
        </div>
      )
    );
  }
}

export default ClearshareEmail;
